import React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCounter } from "../../../hooks/useCounter";
import { useAxios, useAxios2, useAxios3 } from "../../../hooks/useAxios";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Modal from "../../../components/modal2026/Modal";
import ModalVideo from "../../../components/modal2026/ModalVideo.jsx";
import { getReadingTime } from '../../../utils/readingTime.ts';


const Ideas = () => {
    const [t, i18n] = useTranslation("ideaCorta");
    const [t2] = useTranslation("biblioteca");
    const [t3] = useTranslation("global");
    const navigate = useNavigate();
    const [date, setDate] = useState("Desc");
    const [isVisible, setIsVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [offset, setOffset] = useState(0);
    const limit = 8;
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loading, setLoading] = useState(true);


    const { dataS, isLoadingS } = useAxios2(
        `ideas/gnideas?offset=0&next=1000&lang=${i18n.language}`
    );
    const location = useLocation();

    const fetchIdeas = async (currentOffset, searchText, sortValue) => {
        try {
            let url = `${process.env.REACT_APP_API_URL}/ideas/gnideas?offset=${currentOffset}&next=${limit}&lang=${i18n.language}`;

            // 🔍 búsqueda
            if (searchText.length > 1) {
                url = `${process.env.REACT_APP_API_URL}/ideas/searchbytitle?words=${searchText}&offset=${currentOffset}&next=${limit}&lang=${i18n.language}`;
            }

            // 📅 orden
            if (sortValue) {
                url += `&sort=${sortValue}`;
            }

            console.log(url);

            const response = await axios.get(url);
            return response.data;

        } catch (error) {
            console.error(error);
            return [];
        }
    };

    useEffect(() => {
        loadMore(0);
    }, []);

    const loadMore = async (
        customOffset = null,
        force = false,
        searchText = inputVal,
        sortValue = date
    ) => {

        if ((loadingMore || !hasMore) && !force) return;

        if (customOffset === 0 || force) {
            setLoading(true);
        }
        setLoadingMore(true);

        const currentOffset =
            customOffset !== null ? customOffset : offset;

        const data = await fetchIdeas(
            currentOffset,
            searchText,
            sortValue
        );

        if (data.length < limit) {
            setHasMore(false);
        } else {
            setHasMore(true);
        }

        setItems(prev =>
            customOffset === 0
                ? data
                : [...prev, ...data]
        );

        setOffset(currentOffset + limit);

        if (customOffset === 0 || force) {
            setLoading(false);
        }
        setLoadingMore(false);
    };

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Ideas',
            event_label: label,
            value: 1
        });
    };

    useEffect(() => {
        setItems([]);
        setOffset(0);
        setHasMore(true);
        loadMore(0); // 👈 aquí mandas offset limpio
    }, [i18n.language]);

    useEffect(() => {
        if (dataS) {
            dataS.map((element, index) => {
                if (location.pathname.includes(element.preview)) {
                    if (
                        element.tipo === "texto-imagen" ||
                        element.tipo === "texto-video" ||
                        element.tipo === "video" ||
                        element.tipo === "image"
                    ) {
                        openModal(element.contenido, "", element.preview, element.id, element.titulo);
                    }
                    if (element.tipo === "carrete") {
                        openModal(element.contenido, "carrete", element.preview, element.id, element.titulo);
                    }
                }
            });
        }
    }, [dataS]);

    const renderizarMensaje = (tipo, contenido, preview, index, id, titulo) => {
        if (tipo === "texto") {
            return (
                <>
                    <div className="_ngcontent-ng-c485834739 _nghost-ng-c1461349688">
                        <article class="reflexion-video-card reflexion-video-card--text" onClick={() => openModal(contenido, "texto", "", id, titulo)}>
                            <div class="reflexion-video-card__text-surface">
                                <p class="reflexion-video-card__excerpt" dangerouslySetInnerHTML={{ __html: contenido }}></p>
                                <p class="reflexion-video-card__continue">
                                    <span>Continuar leyendo</span>
                                </p>
                                <p class="reflexion-video-card__duration">
                                </p>
                            </div>
                        </article>
                    </div>
                    {/*<div className="_ngcontent-ng-c485834739 no-click-i">
                    <article class="reflexion-video-card reflexion-video-card--text">
                        <div class="reflexion-video-card__text-surface mensageDiv">
                            <div class="reflexion-video-card__excerpt" dangerouslySetInnerHTML={{ __html: contenido }}>

                            </div>
                            <p class="reflexion-video-card__continue"><span
                            ></span></p>
                            <p class="reflexion-video-card__duration"></p>
                        </div>
                    </article>
                </div>*/}
                </>
            );
        } else if (tipo === "imagen") {
            return (
                <>
                    <div className="card-type-img" onClick={() => openModal("https://www.ricardosalinas.com" + preview, "imagen", preview, id, "")}>
                        <img
                            className="img1"
                            src={"https://www.ricardosalinas.com" + preview}
                            alt="Imagen ideas"
                        />
                    </div>
                </>
            );
        } else if (tipo === "texto-video") {
            return (
                <>
                    <div>
                        <article onClick={() => openModal(contenido, "", preview, id, titulo)} class="reflexion-video-card"><img
                            loading="lazy" class="reflexion-video-card__image"
                            src={"https://www.ricardosalinas.com" + preview}
                            alt={titulo} /><button type="button" class="reflexion-video-card__play-button"
                                aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt={titulo}
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                                {getReadingTime(id) && (
                                    <p class="reflexion-video-card__duration reflexion-video-card__duration_sec">{getReadingTime(id)} min</p>
                                )}
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "texto-imagen") {

            return (
                <>
                    <div>
                        <article class="reflexion-video-card reflexion-video-card--story-image"
                            onClick={() => openModal(contenido, "texto-imagen", preview, id, titulo)}>
                            <img loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview} alt={titulo} />
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}
                                </h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "carrete") {
            return (
                <>
                    <div>
                        <article class="reflexion-video-card reflexion-video-card--story-image"
                            onClick={() => openModal(contenido, "carrete", preview, id, titulo)}>
                            <img loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview} alt={titulo} />
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}
                                </h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "youtube") {
            return (
                <>
                    <div>
                        <article onClick={() => openModalVideo(contenido, id)}
                            class="reflexion-video-card"><img
                                loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview}
                                alt={"reproducir "+titulo} /><button type="button" class="reflexion-video-card__play-button"
                                    aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt={"reproducir "+titulo}
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                                {getReadingTime(id) && (
                                    <p class="reflexion-video-card__duration reflexion-video-card__duration_sec">{getReadingTime(id)} min</p>
                                )}
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "video") {
            return (
                <>
                    <div>
                        <article onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id, titulo)}
                            class="reflexion-video-card"><img
                                loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview}
                                alt={"reproducir"+titulo} /><button type="button" class="reflexion-video-card__play-button"
                                    aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt={"reproducir "+titulo}
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                                {getReadingTime(id) && (
                                    <p class="reflexion-video-card__duration reflexion-video-card__duration_sec">{getReadingTime(id)} min</p>
                                )}
                            </div>
                        </article>
                    </div>

                </>
            );
        } else {
            return <p>La condición es falsa que tipo eres-----: {tipo}</p>;
        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [id_liga, setId_liga] = useState("");
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");

    const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
    const [urlVideo, setUrlVideo] = useState("");

    const openModal = (value1, value2, value3, value4, value5) => {
        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value5);
        setId_liga(value4);
        setIsModalOpen(true);
        trackAnalyticsClick('Ideas - Idea: '+value5);
        navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
    };

    const closeModal = () => {
        setVariable1("");
        setVariable2("");
        setVariable3("");
        setIsModalOpen(false);
    };

    const openModalVideo = (contenido, value4) => {
        setUrlVideo(contenido);
        trackAnalyticsClick('Ideas - Idea: '+contenido);
        setIsOpenModalVideo(true);
        navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
    };

    const closeModalVideo = () => {
        setUrlVideo("");
        setIsOpenModalVideo(false);
    };

    const [inputVal, setInputVal] = useState("");
    const [searched, setSearched] = useState(false);

    const notAllowedChars = [
        '"',
        "`",
        "=",
        ";",
        "[",
        "]",
        "{",
        "}",
        "/",
        "\\",
        "&",
        "<",
        ">",
        ":",
        "'",
    ];

    const handleInputChange = (event) => {
        setInputVal(event.target.value);

        const value = event.target.value;

        // Verificar si el valor contiene algún carácter no permitido
        const containsNotAllowedChars = notAllowedChars.some((char) =>
            value.includes(char)
        );
        let cleanBody = "";

        if (containsNotAllowedChars) {
            event.target.classList.add("invalid");
            for (let character of inputVal) {
                cleanBody += notAllowedChars.includes(character) ? "" : character;
            }
            setInputVal(cleanBody);
        } else {
            event.target.classList.remove("invalid");
        }
    };


    const handleClick = () => {

        if (inputVal.length <= 1) return;

        setSearched(true);

        setItems([]);
        setOffset(0);
        setHasMore(true);

        trackAnalyticsClick('Ideas - Busqueda: '+inputVal);

        loadMore(0, true);
    };


    const handleKeyDown = (e) => {
        // Verificar si la tecla presionada es "Enter" (código 13)
        if (e.key === "Enter") {
            handleClick();
        }
    };

    const clearSearch = () => {

        const empty = '';
        const defaultSort = "Desc";

        setInputVal(empty);
        setDate(defaultSort);
        setSearched(false);

        setItems([]);
        setOffset(0);
        setHasMore(true);

        loadMore(0, true, empty, defaultSort);
    };

    useEffect(() => {
        setItems([]);
        setOffset(0);
        setHasMore(true);

        loadMore(0, true); // 👈 fuerza recarga
    }, [date, i18n.language]);

    const IdeasSkeleton = () => (
        <div className="reflexion-video-card reflexion-video-card--skeleton">
            <div className="skeleton-box reflexion-video-card__image" />
            <div className="reflexion-video-card__copy">
                <div className="skeleton-line w-60" />
                <div className="skeleton-line w-80" />
            </div>
        </div>
    );

    return (
        <>
            <div>
                <div className="_ngcontent-ng-c2574764019">
                    <header class="reflexiones-header">
                        <div class="reflexiones-header__heading">
                            <h1 class="reflexiones-header__title">{t("2026.title")}</h1>
                            <p class="reflexiones-header__description only-mov">{t("2026.desc5")}</p>
                        </div>

                        <div aria-label="Controles de video" class="reflexiones-header__controls">
                            <label
                                class="reflexiones-header__control reflexiones-header__control--search"><span
                                    class="reflexiones-header__visually-hidden">{t("2026.buscar")}</span>
                                <input
                                    type="search"
                                    placeholder={t("2026.buscar")}
                                    value={inputVal}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown} />
                                {searched ? (

                                    <button
                                        type="button"
                                        onClick={clearSearch}
                                        className="btn-filt-id"
                                    >
                                        <img
                                            src="/assets/img2026/cerrar-cancelar.svg"
                                            alt="cancelar"
                                            aria-hidden="true"
                                        />
                                    </button>

                                ) : (

                                    <img
                                        onClick={handleClick}
                                        src="/assets/img2026/logo_search.svg"
                                        alt="Buscar"
                                        aria-hidden="true"
                                    />

                                )}

                            </label>
                            <label

                                class="reflexiones-header__control reflexiones-header__control--sort"><span
                                    class="reflexiones-header__visually-hidden">{t("2026.ordenar")}</span>
                                <select
                                    value={date}
                                    onChange={(e) => {
                                        setDate(e.target.value);
                                    }}
                                >
                                    <option value="Desc">{t("2026.filtr4")}</option>
                                    <option value="Asce">{t("2026.filtr5")}</option>
                                </select>


                            </label>

                        </div>
                    </header>
                    <p class="reflexiones-header__description  only-desk">{t("2026.desc5")}</p>
                </div>
                <div className="_ngcontent-ng-c2574764019">
                    <section _ngcontent-ng-c485834739="" aria-label="Videos de reflexión" class="reflexiones-videos">

                        {loading ? (

                            Array.from({ length: 8 }).map((_, i) => (
                                <IdeasSkeleton key={i} />
                            ))

                        ) : items.length === 0 ? (

                            <div className="ideas-empty-state">
                                <h2>{t3("general.noresults")}</h2>

                                <p>
                                    {t3("general.noresults2")}
                                    {inputVal && `: "${inputVal}"`}
                                </p>

                            </div>

                        ) : (

                            items.map((item, index) => (
                                <React.Fragment key={item.id || index}>
                                    {renderizarMensaje(
                                        item.tipo,
                                        item.contenido,
                                        item.preview,
                                        index,
                                        item.id,
                                        item.titulo
                                    )}
                                </React.Fragment>
                            ))

                        )}

                    </section>
                    <div className="reflexiones-videos__load-more">
                        {hasMore && (
                            <button
                                onClick={() => {loadMore(); trackAnalyticsClick('Ideas - Mas ideas');}}
                                disabled={loadingMore}
                                className="reflexiones-videos__load-more-button typo-book-title"
                            >
                                {loadingMore ? t("2026.cargan") : t("2026.conoce")}
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <Modal
                isOpen={isModalOpen}
                closeModal={closeModal}
                variable1={variable1}
                variable2={variable2}
                variable3={variable3}
                id_idea={id_liga}
            />

            <ModalVideo
                isOpen={isOpenModalVideo}
                closeModal={closeModalVideo}
                urlVideo={urlVideo}
            />
        </>
    );
};

export default Ideas;